import app from 'flarum/forum/app';
import Notification from "flarum/components/Notification";
import itemActualCost from "../common/util/itemActualCost";

export default class DecorationStoreSubscriptionNotification extends Notification {
  icon() {
    return "fas fa-store";
  }

  href() {
    return app.route("user.decorationStorePurchase", {
      username: app.session.user.username(),
    });
  }

  content() {
    const notification = this.attrs.notification.subject();
    const content = this.attrs.notification.attribute("content");
    const itemTitle = content.title;
    const itemExpired = content.expired;
    
    return app.translator.trans(itemExpired===1?'ziven-decoration-store.forum.notifications.subscription-expired':'ziven-decoration-store.forum.notifications.subscription-fee-deduction', {
      title: itemTitle
    });
  }

  excerpt() {
    const notification = this.attrs.notification.subject();
    const content = this.attrs.notification.attribute("content");
    const moneyName = app.forum.attribute('antoinefr-money.moneyname') || '[money]';
    const itemExpired = content.expired;
    const itemPurchaseCount = notification.purchase_count();
    const itemPurchaseActualCost = itemActualCost(notification,itemPurchaseCount);
    const itemPurchaseActualCostText = moneyName.replace('[money]', itemPurchaseActualCost);

    return app.translator.trans(itemExpired===1?'ziven-decoration-store.forum.notifications.subscription-expired-excerpt':'ziven-decoration-store.forum.notifications.subscription-fee-deduction-excerpt', {
      cost: itemPurchaseActualCostText
    });
  }
}
